"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: []
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/menu/MainMenuUser.vue
// module id = U6pI
// module chunks = 0 1